{
  "title": "设置",
  "panel": {
    "createTitle": "新建{{title}}",
    "updateTitle": "更新{{title}}",
    "createDescription": "新建{{title}}。",
    "updateDescription": "更新{{title}}。",
    "removeTitle": "移除{{title}}",
    "removeText": "确定要移除此{{title}}吗？此操作无法撤销。",
    "closePanel": "关闭面板",
    "remove": "移除",
    "test": "测试",
    "ok": "成功",
    "error": "错误",
    "cancel": "取消",
    "create": "创建",
    "save": "保存"
  },
  "nav": {
    "application": "应用",
    "logs": "日志",
    "indexers": "索引器",
    "irc": "IRC",
    "feeds": "订阅源",
    "lists": "列表",
    "clients": "下载客户端",
    "notifications": "通知",
    "apiKeys": "API 密钥",
    "proxies": "代理",
    "releases": "发布",
    "account": "账户"
  },
  "application": {
    "title": "应用",
    "description": "应用设置。修改 config.toml 后需重启才能生效。",
    "host": "主机",
    "port": "端口",
    "baseUrl": "基础路径",
    "version": "版本",
    "commit": "提交",
    "buildDate": "构建日期",
    "application": "应用",
    "configPath": "配置路径",
    "database": "数据库",
    "webuiDebugMode": "WebUI 调试模式",
    "checkForUpdates": "检查更新",
    "checkForUpdatesDescription": "有新版本时通知我。",
    "theme": "主题",
    "themeDescription": "可选择浅色、深色或跟随系统主题。",
    "languageDescription": "选择 WebUI 使用的语言。",
    "updateEnabled": "后续有新版本时会通知你。",
    "updateDisabled": "后续将不再通知你新版本更新。",
    "updateAvailable": "{{name}} 可用。"
  },
  "account": {
    "title": "账户",
    "description": "管理账户设置。",
    "required": "必填",
    "passwordsDoNotMatch": "两次输入的密码不一致",
    "updateSuccess": "用户更新成功，请重新登录！",
    "updateError": "更新凭据失败。请确认你填写了正确的当前密码。",
    "changeCredentialsTitle": "修改凭据",
    "changeCredentialsDescription": "用户名和密码可以分别修改，也可以同时修改。注意，修改凭据后你将被退出登录。",
    "currentUsername": "当前用户名",
    "newUsername": "新用户名",
    "optional": "可选",
    "currentPassword": "当前密码",
    "requiredIfUpdatingCredentials": "修改凭据时必填",
    "newPassword": "新密码",
    "confirmNewPassword": "确认新密码",
    "save": "保存",
    "identityProvider": "你的身份提供商",
    "oidcTitle": "OpenID Connect 账户",
    "oidcDescription": "你的账户凭据由 OpenID Connect 提供商管理。如需修改用户名，请前往提供商的设置页面进行修改，然后重新登录。",
    "authenticatedViaOidc": "通过 OpenID Connect 认证"
  },
  "logsPage": {
    "title": "日志",
    "description": "配置日志级别、日志轮转大小等。你也可以在下方下载旧日志文件。",
    "chooseType": "选择类型",
    "updated": "配置更新成功！",
    "path": "路径",
    "setInConfig": "在 config.toml 中设置",
    "notSet": "未设置！",
    "level": "级别",
    "logLevel": "日志级别",
    "maxSize": "最大大小",
    "maxBackups": "最大备份数"
  },
  "regexPlayground": {
    "title": "正则表达式练习场",
    "description": "在这里试验你的过滤器正则表达式。当前仍在开发中。",
    "regexFilter": "正则表达式过滤器",
    "linesToMatch": "待匹配文本",
    "matches": "匹配结果"
  },
  "apiKey": {
    "createTitle": "创建 API 密钥",
    "description": "新增 API 密钥。",
    "created": "API 密钥 {{name}} 已添加",
    "deleted": "API 密钥 {{name}} 已删除",
    "name": "名称",
    "key": "密钥",
    "required": "必填",
    "closePanel": "关闭面板",
    "cancel": "取消",
    "create": "创建",
    "listTitle": "API 密钥",
    "listDescription": "在这里管理你的 autobrr API 密钥。",
    "addNew": "新增",
    "noItems": "暂无 API 密钥",
    "createCta": "创建 API 密钥",
    "removeTitle": "移除 API 密钥：{{name}}",
    "removeText": "确定要移除此 API 密钥吗？此操作无法撤销。",
    "deleteKey": "删除密钥"
  },
  "irc": {
    "listTitle": "IRC",
    "listDescription": "IRC 网络和频道。点击一个网络可查看频道状态。",
    "addNew": "新增",
    "networkHealthy": "网络正常",
    "networkUnhealthy": "网络异常",
    "networkDisabled": "网络已禁用",
    "collapseTitle": "折叠",
    "expandTitle": "展开",
    "collapse": "折叠",
    "expand": "展开",
    "network": "网络",
    "noNetworks": "暂无网络",
    "noNetworksSubtitle": "通常由索引器自动设置",
    "addNewNetwork": "新增网络",
    "toggleSuccess": "{{name}} 已{{state}}成功。",
    "enabledState": "启用",
    "disabledState": "禁用",
    "connectedSince": "连接开始于：{{time}}",
    "tlsSecured": "已使用 TLS 加密",
    "tlsInsecure": "未使用 TLS，不安全",
    "channel": "频道",
    "monitoringSince": "监控开始时间",
    "lastAnnounce": "最后一次公告",
    "monitoring": "监控中",
    "hide": "隐藏",
    "view": "查看",
    "networkDeleted": "网络 {{name}} 已删除",
    "networkRestarted": "{{name}} 已成功重启",
    "removeNetworkTitle": "移除网络：{{name}}",
    "removeNetworkText": "确定要移除此网络吗？此操作无法撤销。",
    "edit": "编辑",
    "restart": "重启",
    "delete": "删除",
    "announceReprocessed": "公告已发送重新处理！",
    "reprocessAnnounce": "重新处理公告",
    "options": "选项",
    "scrollOnNewMessage": "新消息时滚动到底部",
    "title": "网络",
    "addWarning": "请通过索引器添加网络！仅在你删除了网络时才使用这里",
    "added": "IRC 网络已添加。请等待最多 30 秒让网络上线。",
    "addFailed": "IRC 网络添加失败",
    "updated": "{{name}} 更新成功",
    "deleted": "{{name}} 已删除。",
    "required": "必填",
    "name": "名称",
    "enabled": "启用",
    "server": "服务器",
    "serverPlaceholder": "地址：例如 irc.server.net",
    "port": "端口",
    "portPlaceholder": "例如 6667",
    "tls": "TLS",
    "skipTls": "跳过 TLS 校验（不安全）",
    "password": "密码",
    "passwordHelp": "网络密码",
    "passwordUpdateHelp": "网络密码，不常用。",
    "nick": "昵称",
    "nickPlaceholderAdd": "机器人昵称",
    "nickPlaceholderUpdate": "昵称",
    "authAccount": "认证账户",
    "authAccountPlaceholder": "认证账户",
    "authPassword": "认证密码",
    "inviteCommand": "邀请命令",
    "channels": "频道",
    "channelsDesc": "要加入的频道。",
    "channelsUpdateDesc": "频道会在你设置 IRC 索引器时自动添加。除非你很清楚自己在做什么，否则不要修改。",
    "channelPassword": "频道密码",
    "remove": "移除",
    "noChannels": "暂无频道！",
    "addChannel": "添加频道",
    "bouncer": "Bouncer (BNC)",
    "bouncerAddress": "Bouncer 地址",
    "bouncerAddressHelp": "地址：例如 bouncer.server.net:6697",
    "botMode": "IRCv3 机器人模式",
    "proxy": "代理",
    "proxyDesc": "为连接 IRC 服务器设置代理。",
    "selectProxy": "选择代理",
    "selectProxyPlaceholder": "选择一个代理",
    "identification": "身份验证",
    "identificationDesc": "通过 SASL 或 NickServ 验证。大多数网络支持 SASL，但也有部分不支持。",
    "mechanism": "机制",
    "account": "账户",
    "accountHelp": "NickServ / SASL 账户。若昵称分组，尽量使用主账户。",
    "passwordSaslHelp": "NickServ / SASL 密码。",
    "chooseType": "选择类型"
  },
  "releases": {
    "warningTitle": "警告：",
    "warningBody": "此区域用于管理发布历史删除。自动清理任务会按计划运行，手动删除则会立即执行一次性清理。这两种操作都会永久删除数据，且无法撤销。",
    "olderThan": "早于",
    "olderThanDesc": "发布在删除前需要达到的时长（自动与手动删除都必填）",
    "indexers": "索引器",
    "indexersDesc": "可选过滤条件（不选则作用于所有索引器）",
    "releaseStatuses": "发布状态",
    "releaseStatusesDesc": "可选过滤条件（不选则作用于所有发布状态）",
    "duplicateProfilesTitle": "发布去重配置",
    "duplicateProfilesDesc": "管理重复发布配置。",
    "cleanupJobsTitle": "发布清理任务",
    "cleanupJobsDesc": "通过自定义过滤条件安排自动清理旧发布。",
    "addNew": "新增",
    "edit": "编辑",
    "enabled": "启用",
    "name": "名称",
    "lastRun": "上次运行",
    "nextRun": "下次运行",
    "runNow": "立即运行",
    "delete": "删除",
    "never": "从未",
    "deleteReleaseHistory": "删除发布历史",
    "deleteReleaseHistoryDesc": "选择下列条件，永久删除早于指定时间，且可选匹配指定索引器和发布状态的发布历史记录：",
    "removeReleases": "删除发布记录",
    "invalidAge": "请选择有效的时间。",
    "invalidAgeExample": "请输入有效的时间，例如 6 months 或 1 year。",
    "allDeleted": "已删除所有符合条件的发布记录。",
    "olderThanDeleted": "已删除早于 {{duration}} 的发布记录。",
    "allIndexers": "所有索引器",
    "selectedIndexers": "所选索引器",
    "removeCleanupJobTitle": "删除清理任务：{{name}}",
    "removeCleanupJobText": "确定要删除这个清理任务吗？此操作无法撤销。",
    "cleanupJobToggled": "{{name}} 已{{state}}",
    "cleanupJobTriggered": "{{name}} 已触发",
    "cleanupJobDeleted": "{{name}} 已删除",
    "cleanupJobEnabled": "启用",
    "cleanupJobDisabled": "禁用",
    "duplicateFieldTitles": {
      "releaseName": "发布名称",
      "hash": "发布名称标准化后的哈希。与发布名称一起使用可实现精确匹配",
      "title": "解析后的标题",
      "subTitle": "解析后的副标题，例如剧集名称",
      "group": "发布组",
      "year": "年份",
      "month": "月份",
      "day": "日期",
      "source": "来源",
      "resolution": "分辨率",
      "codec": "编码",
      "container": "容器",
      "dynamicRange": "动态范围（HDR、DV）",
      "audio": "音频格式",
      "season": "季号",
      "episode": "集号",
      "website": "网站/服务",
      "proper": "Scene proper",
      "repack": "Scene repack",
      "edition": "版本（例如 Collectors Edition）和剪辑版本（例如 Directors Cut）",
      "language": "语言和地区"
    },
    "noDuplicateProfiles": "暂无重复发布配置",
    "addNewProfile": "新增配置",
    "noCleanupJobs": "暂无清理任务",
    "createCleanupSchedules": "创建自动清理计划",
    "addNewJob": "新增任务",
    "removeReleasesText": "你即将{{scope}}。",
    "removeReleasesScopeAll": "删除 {{indexers}}{{statuses}} 的所有发布历史记录",
    "removeReleasesScopeOlder": "永久删除 {{indexers}}{{statuses}} 中早于 {{duration}} 的所有发布历史记录",
    "removeReleasesStatuses": "，且发布状态为：{{statuses}}",
    "duration": {
      "allTime": "全部时间",
      "hour1": "1 小时",
      "hours12": "12 小时",
      "day1": "1 天",
      "week1": "1 周",
      "month1": "1 个月",
      "months3": "3 个月",
      "months6": "6 个月",
      "year1": "1 年",
      "invalid": "无效时长"
    }
  },
  "forms": {
    "downloadClient": {
      "remove": "移除",
      "test": "测试",
      "ok": "成功",
      "error": "错误",
      "cancel": "取消",
      "create": "创建",
      "save": "保存",
      "added": "客户端已添加",
      "addFailed": "客户端添加失败",
      "updated": "{{name}} 更新成功",
      "deleted": "{{name}} 已删除。",
      "addTitle": "新增客户端",
      "addDescription": "添加下载客户端。",
      "editTitle": "编辑客户端",
      "editDescription": "编辑下载客户端设置。",
      "removeTitle": "移除下载客户端",
      "removeText": "确定要移除此下载客户端吗？此操作无法撤销。",
      "closePanel": "关闭面板",
      "name": "名称",
      "enabled": "启用",
      "type": "类型",
      "host": "主机",
      "port": "端口",
      "tls": "TLS",
      "skipTls": "跳过 TLS 校验（不安全）",
      "username": "用户名",
      "password": "密码",
      "apiKey": "API 密钥",
      "authToken": "认证令牌",
      "basicAuth": "基础认证",
      "auth": "认证",
      "authType": "认证类型",
      "selectAuthType": "选择认证类型",
      "authTypeTooltip": "大多数情况下这里应使用 Basic Auth，但有些服务商会使用 Digest Auth。",
      "hostHelpDeluge": "例如：client.domain.ltd、domain.ltd/client、domain.ltd:port",
      "hostHelpArr": "完整 URL，例如 http(s)://domain.ltd，以及可选的子域名/子路径",
      "hostHelpQbit": "例如：http(s)://client.domain.ltd、http(s)://domain.ltd/qbittorrent、http://domain.ltd:port",
      "hostHelpPorla": "例如：http(s)://client.domain.ltd、http(s)://domain.ltd/porla、http://domain.ltd:port",
      "hostHelpRTorrent": "例如：http(s)://client.domain.ltd/RPC2、http(s)://domain.ltd/client、http(s)://domain.ltd/RPC2",
      "hostHelpTransmission": "例如：http(s)://client.domain.ltd、http(s)://domain.ltd/transmission",
      "hostHelpSabnzbd": "例如：http://ip:port 或 https://url.com/sabnzbd",
      "hostHelpNzbget": "例如：http://localhost:6789",
      "daemonPort": "守护进程端口",
      "webUiPortQbit": "qBittorrent WebUI 端口",
      "transmissionPort": "Transmission 端口",
      "sabnzbdPort": "SABnzbd 端口",
      "guidesDeluge": "查看文档了解如何在不同服务器类型下连接 Deluge。",
      "guidesArr": "查看文档了解如何在不同服务器类型下连接 *arr 套件。",
      "guidesQbit": "查看文档了解如何在不同服务器类型下连接 qBittorrent。",
      "guidesRTorrent": "查看文档了解如何在不同服务器类型下连接 rTorrent。",
      "guidesTransmission": "查看文档了解如何在不同服务器类型下连接 Transmission。",
      "guidesSabnzbd": "查看文档了解如何在不同服务器类型下连接 SABnzbd。",
      "dedicatedServers": "独立服务器：",
      "sharedSeedboxProviders": "共享 seedbox 服务商：",
      "rulesTitle": "规则",
      "rulesDescriptionBasic": "管理最大下载数。",
      "rulesDescriptionAdvanced": "管理最大下载数等规则。",
      "maxActiveDownloads": "最大活跃下载数",
      "maxActiveDownloadsTooltip": "限制活跃下载数量（0 表示无限），以便为当前下载保留更多带宽和磁盘资源。",
      "seeRecommendations": "不同服务器类型的建议可参考：",
      "downloadClientTitle": "下载客户端",
      "downloadClientDescription": "覆盖默认使用的下载客户端，也可以在每个过滤器动作中单独覆盖。",
      "clientName": "客户端名称",
      "clientNameTooltip": "指定 arr 默认应使用哪个客户端，也可在每个过滤器动作中覆盖。",
      "clientIdDeprecated": "客户端 ID（已弃用）",
      "clientIdDeprecatedTooltip": "已弃用：请改用客户端名称字段。",
      "ignoreSlowTorrents": "忽略慢速种子",
      "ignoreCondition": "忽略条件",
      "selectIgnoreCondition": "选择忽略条件",
      "ignoreConditionTooltip": "在检查速度阈值前，选择是遵守还是忽略“最大活跃下载数”设置。",
      "downloadSpeedThreshold": "下载速度阈值",
      "uploadSpeedThreshold": "上传速度阈值",
      "speedThresholdPlaceholder": "单位 KB/s",
      "downloadSpeedThresholdHelp": "当达到最大活跃下载数时，如果下载速度低于此值，仍然继续下载。单位 KB/s",
      "uploadSpeedThresholdHelp": "当达到最大活跃下载数时，如果上传速度低于此值，仍然继续下载。单位 KB/s"
    },
    "feed": {
      "title": "订阅源",
      "updated": "{{name}} 更新成功",
      "deleted": "{{name}} 已删除。",
      "testOk": "{{name}} 测试成功！",
      "name": "名称",
      "type": "类型",
      "enabled": "启用",
      "warningTitle": "警告：抓取间隔过低时，索引器可能会封禁你！",
      "warningText": "请阅读索引器规则。",
      "url": "URL",
      "torznabUrlHelp": "Torznab URL，仅填写 URL，不要附带额外参数。",
      "newznabUrlHelp": "Newznab URL，仅填写 URL，不要附带额外参数。",
      "rssUrlHelp": "RSS URL",
      "urlFormatTitle": "Prowlarr 和 Jackett 的格式不同：",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "downloadType": "下载类型",
      "apiKey": "API 密钥",
      "skipTls": "跳过 TLS 校验（不安全）",
      "refreshInterval": "刷新间隔",
      "refreshIntervalHelp": "单位分钟。推荐 15-30，过低可能导致被封禁。",
      "refreshTimeout": "刷新超时",
      "refreshTimeoutHelp": "取消刷新前等待的秒数。",
      "maxAge": "最大时长",
      "maxAgeHelp": "订阅内容的最大年龄，单位秒。填 0 可禁用年龄过滤并处理所有内容。",
      "cookie": "Cookie",
      "cookieHelp": "不常用",
      "categoriesTitle": "分类",
      "categoriesDescription": "抓取可用分类并选择需要包含的项。",
      "fetch": "抓取",
      "fetching": "抓取中",
      "refetch": "重新抓取",
      "fetchFailed": "抓取分类失败",
      "noCategories": "未找到分类。",
      "fetchToSelect": "先抓取分类再进行选择。"
    },
    "list": {
      "added": "列表已添加！",
      "addFailed": "列表添加失败",
      "updated": "{{name}} 更新成功",
      "deleted": "{{name}} 已删除。",
      "name": "名称",
      "type": "类型",
      "enabled": "启用",
      "filters": "过滤器",
      "addTitle": "新增列表",
      "updateTitle": "更新列表",
      "description": "从列表和 arr 自动更新过滤器。",
      "closePanel": "关闭面板",
      "chooseType": "选择类型",
      "chooseClient": "选择客户端",
      "selectClient": "选择客户端",
      "selectClientLabel": "选择客户端",
      "filtersDescription": "选择需要由该列表更新的过滤器。",
      "cancel": "取消",
      "remove": "移除",
      "save": "保存",
      "saving": "保存中..",
      "selectSomeItems": "请选择...",
      "allItemsSelected": "已选择全部",
      "selectAll": "全选",
      "search": "搜索",
      "noOptions": "没有可选项",
      "removeTitle": "移除 {{name}}",
      "removeText": "确定要移除 {{name}} 吗？此操作无法撤销。",
      "required": "必填",
      "settingsLegend": "设置",
      "source": "来源",
      "sourceList": "来源列表",
      "arrSourceDescription": "从 Radarr、Sonarr、Lidarr、Readarr 或 Whisparr 中的标题更新过滤器。",
      "traktSourceDescription": "使用 Trakt 列表或 autobrr 默认托管列表。",
      "anilistSourceDescription": "使用 autobrr 默认托管的 AniList 列表。",
      "plaintextSourceDescription": "使用纯文本列表，每行一个条目。",
      "steamSourceDescription": "跟踪 Steam 愿望单。",
      "metacriticSourceDescription": "使用 Metacritic 列表或 autobrr 默认托管列表。",
      "mdblistSourceDescription": "使用 MDBList 列表或 autobrr 默认托管列表。",
      "listUrl": "列表 URL",
      "traktHelp": "默认 Trakt 列表，可替换为你自己的。",
      "traktApiKey": "API 密钥",
      "traktApiKeyHelp": "Trakt API 密钥。私有列表需要填写。",
      "matchRelease": "匹配发布名",
      "matchReleaseDesc": "使用 Match Releases 字段，默认使用 Movies/Shows 字段。",
      "includeUnmonitored": "包含未监控项",
      "includeUnmonitoredDesc": "默认仅过滤已监控的标题。",
      "includeAlternateTitles": "包含别名标题",
      "includeAlternateTitlesDesc": "在过滤器中包含备用标题。",
      "skipCleanSanitize": "跳过清理和规范化，按原样使用列表",
      "skipCleanSanitizeDesc": "默认会自动清理标题并检查异常字符。",
      "tagsIncluded": "包含标签",
      "tagsExcluded": "排除标签",
      "metacriticHelp": "默认 Metacritic 列表，可替换为你自己的。",
      "mdblistHelp": "MDBLists.com 列表，可替换为你自己的。",
      "includeYear": "包含年份",
      "includeYearDesc": "对电影在过滤器中包含发布年份。需要启用 Match Releases。例如：Movie?Title?2024*",
      "plaintextUrlHelp": "纯文本文件 URL，每行一个条目",
      "plaintextUrlPlaceholder": "https://example.com/list.txt",
      "plaintextTooltip1": "纯文本列表既支持 HTTP URL，也支持磁盘上的本地文件。",
      "plaintextTooltipRemote": "远程：https://service.com/file.txt",
      "plaintextTooltipLocal": "本地：file:///home/username/file.txt",
      "url": "URL",
      "steamUrlHelp": "Steam 愿望单 URL",
      "steamUrlPlaceholder": "https://store.steampowered.com/wishlist/id/USERNAME/wishlistdata"
    },
    "proxy": {
      "title": "代理",
      "addTitle": "新增代理",
      "addDescription": "添加可供索引器或 IRC 使用的代理。",
      "added": "代理已添加！",
      "addFailed": "代理添加失败",
      "updated": "代理 {{name}} 已更新！",
      "updateFailed": "代理更新失败",
      "deleted": "代理 {{name}} 已删除。",
      "name": "名称",
      "closePanel": "关闭面板",
      "enabled": "启用",
      "proxyType": "代理类型",
      "proxyTypeTooltip": "代理类型，通常为 SOCKS5。",
      "proxyTypeHelp": "通常使用 SOCKS5",
      "addr": "地址",
      "addrHelp": "地址：scheme://ip:port 或 scheme://domain",
      "user": "用户",
      "userHelp": "认证：用户名",
      "pass": "密码",
      "passHelp": "认证：密码",
      "test": "测试",
      "cancel": "取消",
      "save": "保存"
    },
  "apiKey": {
    "createTitle": "创建 API 密钥",
    "description": "新增 API 密钥。",
    "created": "API 密钥 {{name}} 已添加",
    "deleted": "API 密钥 {{name}} 已删除",
    "name": "名称",
    "key": "密钥",
    "required": "必填",
    "closePanel": "关闭面板",
    "cancel": "取消",
    "create": "创建",
    "listTitle": "API 密钥",
    "listDescription": "在这里管理你的 autobrr API 密钥。",
    "addNew": "新增",
    "noItems": "暂无 API 密钥",
    "createCta": "创建 API 密钥",
    "removeTitle": "移除 API 密钥：{{name}}",
    "removeText": "确定要移除此 API 密钥吗？此操作无法撤销。",
    "deleteKey": "删除密钥"
  },
    "notification": {
      "settings": "设置",
      "settingsDescDiscordPrefix": "在你的服务器中创建一个",
      "settingsDescDiscordSuffix": "。",
      "discordWebhookIntegration": "Webhook 集成",
      "settingsDescNotifiarr": "启用 autobrr 集成，并可选择创建一个新的 API 密钥。",
      "settingsDescLunasea1": "LunaSea 可将通知发送到与你账户关联的所有设备（基于用户），或通过每台设备独有的 webhook 发送到单台设备（基于设备）。",
      "settingsDescLunasea2Prefix": "阅读 ",
      "settingsDescLunasea2Suffix": "。",
      "lunaseaDocs": "LunaSea 文档",
      "settingsDescTelegramPrefix": "了解如何 ",
      "settingsDescTelegramSuffix": "。",
      "createBot": "创建机器人",
      "settingsDescPushoverPrefix": "注册一个新的",
      "settingsDescPushoverSuffix": "，并把它的 API Token 填到这里。",
      "pushoverApplication": "应用",
      "eventSounds": "事件声音",
      "eventSoundsDesc": "为不同事件设置自定义声音",
      "settingsDescWebhook": "向用户自定义的 webhook URL 发送通用 autobrr JSON 负载。",
      "added": "通知已添加！",
      "addFailed": "通知添加失败",
      "updated": "{{name}} 更新成功",
      "deleted": "{{name}} 已删除。",
      "required": "必填",
      "addTitle": "新增通知",
      "addDescription": "在不同事件上触发通知。",
      "title": "通知",
      "name": "名称",
      "type": "类型",
      "enabled": "启用",
      "chooseType": "选择类型",
      "closePanel": "关闭面板",
      "globalEvents": "全局事件",
      "globalEventsDesc": "选择全局默认触发事件。这些设置可以在单个过滤器上覆盖。若全部不选，则该服务仅用于过滤器级通知。",
      "perFilterEvents": "按过滤器事件",
      "perFilterEventsDesc": "此通知当前被以下过滤器使用。",
      "notUsedInFilters": "未被任何过滤器使用",
      "muted": "静音",
      "test": "测试",
      "cancel": "取消",
      "save": "保存",
      "notificationsLegend": "通知",
      "defaultTone": "默认（用户默认提示音）",
      "webhookUrl": "Webhook URL",
      "discordWebhookPlaceholder": "https://discordapp.com/api/webhooks/xx/xx",
      "discordWebhookHelp": "Discord 频道 webhook URL",
      "notifiarrApiKey": "API 密钥",
      "notifiarrApiKeyHelp": "Notifiarr API 密钥",
      "lunaseaWebhookPlaceholder": "https://notify.lunasea.app/v1/custom/user/TOKEN",
      "lunaseaWebhookHelp": "LunaSea Webhook URL",
      "botToken": "机器人 Token",
      "botTokenHelp": "机器人 Token",
      "chatId": "聊天 ID",
      "chatIdHelp": "聊天 ID",
      "messageThreadId": "消息线程 ID",
      "messageThreadIdHelp": "超级群组中的消息线程（topic）",
      "telegramProxy": "Telegram API 代理",
      "telegramProxyHelp": "api.telegram.org 的反向代理域名。只有在当前网络屏蔽 Telegram API 时才需要填写。",
      "telegramProxyPlaceholder": "http(s)://ip:port",
      "sender": "发送者",
      "senderHelp": "显示在通知顶部的自定义发送者名称",
      "senderPlaceholder": "autobrr",
      "apiToken": "API Token",
      "apiTokenHelp": "API Token",
      "userKey": "用户密钥",
      "userKeyHelp": "用户密钥",
      "priority": "优先级",
      "pushoverPriorityHelp": "-2、-1、0（默认）、1 或 2",
      "gotifyUrl": "Gotify URL",
      "gotifyUrlHelp": "Gotify URL（不包含 /message）",
      "gotifyUrlPlaceholder": "https://some.gotify.server.com",
      "applicationToken": "应用 Token",
      "applicationTokenHelp": "应用 Token",
      "ntfyUrl": "NTFY URL",
      "ntfyUrlHelp": "NTFY URL",
      "ntfyUrlPlaceholder": "https://ntfy.sh/mytopic",
      "username": "用户名",
      "usernameHelp": "用户名",
      "password": "密码",
      "passwordHelp": "密码",
      "accessToken": "访问令牌",
      "accessTokenHelp": "访问令牌。使用它或用户名加密码之一即可",
      "tags": "Tags",
      "ntfyTagsHelp": "用于 ntfy 通知的逗号分隔标签/图标",
      "ntfyTagsPlaceholder": "download,arr,white_check_mark",
      "ntfyPriorityHelp": "最大 5、4、3（默认）、2、1 最小",
      "url": "URL",
      "urlHelp": "URL",
      "shoutrrrDocsPrefix": "查看完整文档 ",
      "shoutrrrServices": "Services",
      "shoutrrrUrlPlaceholder": "smtp://username:password@host:port/?from=fromAddress&to=recipient1",
      "httpMethod": "HTTP 方法",
      "httpMethodDefault": "POST（默认）",
      "httpMethodTooltip": "Webhook 请求使用的 HTTP 方法，默认是 POST。",
      "webhookPlaceholder": "https://example.com/webhook",
      "customHeaders": "自定义请求头",
      "customHeadersHelp": "逗号分隔的 KEY=value 键值对（例如 Authorization=Bearer token,X-Custom=value）",
      "customHeadersPlaceholder": "Authorization=Bearer token,X-Custom-Header=value"
    },
    "irc": {
      "listTitle": "IRC",
      "listDescription": "IRC 网络和频道。点击一个网络可查看频道状态。",
      "addNew": "新增",
      "networkHealthy": "网络正常",
      "networkUnhealthy": "网络异常",
      "networkDisabled": "网络已禁用",
      "collapseTitle": "折叠",
      "expandTitle": "展开",
      "collapse": "折叠",
      "expand": "展开",
      "network": "网络",
      "noNetworks": "暂无网络",
      "noNetworksSubtitle": "通常由索引器自动设置",
      "addNewNetwork": "新增网络",
      "toggleSuccess": "{{name}} 已{{state}}成功。",
      "enabledState": "启用",
      "disabledState": "禁用",
      "connectedSince": "连接开始于：{{time}}",
      "tlsSecured": "已使用 TLS 加密",
      "tlsInsecure": "未使用 TLS，不安全",
      "channel": "频道",
      "monitoringSince": "监控开始时间",
      "lastAnnounce": "最后一次公告",
      "monitoring": "监控中",
      "hide": "隐藏",
      "view": "查看",
      "networkDeleted": "网络 {{name}} 已删除",
      "networkRestarted": "{{name}} 已成功重启",
      "removeNetworkTitle": "移除网络：{{name}}",
      "removeNetworkText": "确定要移除此网络吗？此操作无法撤销。",
      "edit": "编辑",
      "restart": "重启",
      "delete": "删除",
      "announceReprocessed": "公告已发送重新处理！",
      "reprocessAnnounce": "重新处理公告",
      "options": "选项",
      "scrollOnNewMessage": "新消息时滚动到底部",
      "title": "网络",
      "addWarning": "请通过索引器添加网络！仅在你删除了网络时才使用这里",
      "added": "IRC 网络已添加。请等待最多 30 秒让网络上线。",
      "addFailed": "IRC 网络添加失败",
      "updated": "{{name}} 更新成功",
      "deleted": "{{name}} 已删除。",
      "required": "必填",
      "name": "名称",
      "enabled": "启用",
      "server": "服务器",
      "serverPlaceholder": "地址：例如 irc.server.net",
      "port": "端口",
      "portPlaceholder": "例如 6667",
      "tls": "TLS",
      "skipTls": "跳过 TLS 校验（不安全）",
      "password": "密码",
      "passwordHelp": "网络密码",
      "passwordUpdateHelp": "网络密码，不常用。",
      "nick": "昵称",
      "nickPlaceholderAdd": "机器人昵称",
      "nickPlaceholderUpdate": "昵称",
      "authAccount": "认证账户",
      "authAccountPlaceholder": "认证账户",
      "authPassword": "认证密码",
      "inviteCommand": "邀请命令",
      "channels": "频道",
      "channelsDesc": "要加入的频道。",
      "channelsUpdateDesc": "频道会在你设置 IRC 索引器时自动添加。除非你很清楚自己在做什么，否则不要修改。",
      "channelPassword": "频道密码",
      "remove": "移除",
      "noChannels": "暂无频道！",
      "addChannel": "添加频道",
      "bouncer": "Bouncer (BNC)",
      "bouncerAddress": "Bouncer 地址",
      "bouncerAddressHelp": "地址：例如 bouncer.server.net:6697",
      "botMode": "IRCv3 机器人模式",
      "proxy": "代理",
      "proxyDesc": "为连接 IRC 服务器设置代理。",
      "selectProxy": "选择代理",
      "selectProxyPlaceholder": "选择一个代理",
      "identification": "身份验证",
      "identificationDesc": "通过 SASL 或 NickServ 验证。大多数网络支持 SASL，但也有部分不支持。",
      "mechanism": "机制",
      "account": "账户",
      "accountHelp": "NickServ / SASL 账户。若昵称分组，尽量使用主账户。",
      "passwordSaslHelp": "NickServ / SASL 密码。",
      "chooseType": "选择类型"
    },
    "indexer": {
      "title": "索引器",
      "addTitle": "新增索引器",
      "addDescription": "添加索引器。",
      "added": "索引器已添加",
      "addFailed": "索引器添加失败",
      "updated": "{{name}} 更新成功",
      "deleted": "{{name}} 已删除。",
      "indexer": "索引器",
      "chooseIndexer": "选择索引器",
      "required": "必填",
      "defaultValueValidation": "当前仍是默认值，请修改",
      "enabled": "启用",
      "baseUrl": "基础 URL",
      "baseUrlHelp": "如果被 ISP 屏蔽，可覆盖基础 URL。",
      "cancel": "取消",
      "save": "保存",
      "closePanel": "关闭面板",
      "ircTitle": "IRC",
      "ircDesc": "网络和频道会在后台自动配置。",
      "torznabTitle": "Torznab",
      "torznabDesc": "Torznab 订阅源",
      "newznabTitle": "Newznab",
      "newznabDesc": "Newznab 订阅源",
      "rssTitle": "RSS",
      "rssDesc": "RSS 订阅源",
      "settingsIrcTitle": "IRC",
      "settingsIrcDesc": "网络和频道会在后台自动配置。",
      "ircGuideTooltip": "如果你对 IRC 不熟悉，请先阅读我们的 IRC 指南。",
      "name": "名称",
      "url": "URL",
      "torznabUrlHelp": "Torznab URL，仅填写 URL，不要附带额外参数。",
      "newznabUrlHelp": "Newznab URL，仅填写 URL，不要附带额外参数。",
      "urlFormatTitle": "Prowlarr 和 Jackett 的格式不同：",
      "prowlarr": "Prowlarr",
      "jackett": "Jackett",
      "apiKey": "API 密钥",
      "downloadType": "下载类型",
      "downloadTypeTooltip": "有些订阅源需要强制设置为 Magnet。",
      "downloadTypeHelp": "根据索引器设置为 Torrent 或 Magnet。",
      "downloadTypeTooltip2": "有些订阅源需要强制设置为 Magnet。",
      "categoriesTitle": "分类",
      "categoriesDescription": "抓取可用分类并选择需要包含的项。",
      "fetch": "抓取",
      "fetching": "抓取中",
      "refetch": "重新抓取",
      "fetchFailed": "抓取分类失败",
      "fetchNeedsUrl": "请先输入 URL 再抓取分类",
      "noCategories": "未找到分类。",
      "fetchToSelect": "先抓取分类再进行选择。",
      "testApi": "测试 API",
      "testApiSuccess": "API 测试成功！",
      "ok": "成功",
      "error": "错误",
      "externalIdentifier": "外部标识符",
      "externalIdentifierHelp": "供 ARR 使用的外部标识符。如果使用 Prowlarr，请设置为：{{name}} (Prowlarr)",
      "externalIdentifierTooltip1": "供 ARR 使用的外部标识符，可支持做种限制等功能。",
      "externalIdentifierTooltip2": "这个值需要与你 ARR 中的索引器名称一致。如果使用 Prowlarr，通常会是“{{name}} (Prowlarr)”",
      "secretFieldTooltip": "这个字段不能填写完整 URL。这里只应填写类似 uqcdi67cibkx3an8cmdm 这样的字母数字字符串。",
      "proxy": "代理",
      "proxyDesc": "为下载 `.torrent` 文件和订阅源设置代理。",
      "selectProxy": "选择代理",
      "selectProxyPlaceholder": "选择一个代理",
      "chooseType": "选择类型",
      "editFeeds": "在设置 -> 订阅源中编辑 RSS 订阅源"
    },
    "releaseProfile": {
      "title": "重复发布配置",
      "added": "配置已添加",
      "addFailed": "配置添加失败",
      "deleted": "配置 {{name}} 已删除！",
      "fields": {
        "name": "名称",
        "releaseName": "发布名称",
        "hash": "哈希",
        "title": "标题",
        "subTitle": "副标题",
        "year": "年份",
        "month": "月份",
        "day": "日期",
        "source": "来源",
        "resolution": "分辨率",
        "codec": "编码",
        "container": "封装格式",
        "dynamicRange": "动态范围",
        "audio": "音频",
        "group": "小组",
        "season": "季",
        "episode": "集",
        "website": "网站/平台",
        "proper": "Proper",
        "repack": "Repack",
        "edition": "版本",
        "hybrid": "混合版本",
        "language": "语言"
      },
      "descriptions": {
        "releaseName": "完整发布名称",
        "hash": "发布名称的规范化哈希。配合“发布名称”可实现精确匹配",
        "title": "解析后的标题",
        "subTitle": "解析后的副标题，例如剧集名称",
        "dailyReleases": "适用于日报类发布",
        "group": "发布小组",
        "website": "如 AMZN/HULU/NF 等服务平台",
        "dynamicRange": "动态范围（HDR、DV 等）",
        "edition": "版本和剪辑版",
        "language": "语言和地区"
      }
    },
    "cleanupJob": {
      "title": "清理任务",
      "created": "清理任务已创建",
      "createFailed": "清理任务创建失败",
      "updated": "清理任务已更新",
      "updateFailed": "清理任务更新失败",
      "deleted": "{{name}} 已删除",
      "enableDesc": "启用此清理任务",
      "namePlaceholder": "每周清理",
      "schedule": "计划（Cron）",
      "schedulePlaceholder": "0 3 * * *",
      "scheduleHelp": "Cron 表达式。例如：'0 3 * * *' 表示每天凌晨 3 点，'0 */6 * * *' 表示每 6 小时一次",
      "olderThan": "早于",
      "olderThanPlaceholder": "30",
      "olderThanHelp": "删除早于该时长的发布记录",
      "indexersOptional": "索引器（可选）",
      "statusesOptional": "状态（可选）",
      "leaveEmptyIndexers": "留空则应用于所有索引器",
      "leaveEmptyStatuses": "留空则应用于所有状态",
      "executionHistory": "执行历史",
      "lastRun": "上次运行：",
      "status": "状态："
    }
  },
  "listScreens": {
    "common": {
      "enabled": "启用",
      "name": "名称",
      "type": "类型",
      "edit": "编辑",
      "addNew": "新增",
      "unknownError": "发生了未知错误"
    },
    "downloadClients": {
      "title": "下载客户端",
      "description": "管理下载客户端。",
      "host": "主机",
      "noItems": "暂无下载客户端",
      "addNewItem": "新增客户端",
      "toggleSuccess": "{{name}}已{{state}}成功。",
      "enabledState": "启用",
      "disabledState": "禁用"
    },
    "notifications": {
      "title": "通知",
      "description": "配置通知服务及其全局事件触发器。",
      "events": "事件",
      "filters": "过滤器",
      "noItems": "暂无通知",
      "addNewItem": "创建新通知",
      "infoTitle": "按过滤器覆盖：",
      "infoBody": "你可以在每个过滤器的 Notifications 标签页中覆盖这些全局设置。全局事件是可选的，你可以创建没有任何事件的通知服务，仅在过滤器级别配置它们。系统事件（IRC 断开/重连、应用更新）始终使用全局设置。",
      "toggleSuccess": "{{name}}已{{state}}成功。",
      "enabledState": "启用",
      "disabledState": "禁用"
    },
    "indexers": {
      "title": "索引器",
      "description": "IRC、RSS、Newznab 和 Torznab 类型索引器的设置。",
      "descriptionGeneric": "你也可以在这里通过选择其中一个 <strong>Generic</strong> 索引器来添加通用 RSS/Newznab/Torznab 订阅源。",
      "implementation": "实现",
      "noItems": "暂无索引器",
      "addNewItem": "新增索引器",
      "updated": "{{name}} 更新成功"
    },
    "proxies": {
      "title": "代理",
      "description": "可供索引器、订阅源和 IRC 使用的代理。",
      "noItems": "暂无代理",
      "addNewItem": "新增代理",
      "toggleSuccess": "代理 {{name}}已{{state}}成功。",
      "toggleError": "代理状态更新失败",
      "enabledState": "启用",
      "disabledState": "禁用"
    },
    "lists": {
      "title": "列表",
      "description": "列表可以自动从 arr 或其他来源更新你的过滤器。",
      "filters": "过滤器",
      "noItems": "暂无列表",
      "addNewItem": "新增列表",
      "toggleSuccess": "列表 {{name}}已{{state}}成功。",
      "toggleError": "列表状态更新失败",
      "refreshSuccess": "列表 {{name}} 抓取成功。",
      "refreshError": "刷新 {{name}} 失败。错误：{{error}}",
      "deleted": "{{name}} 已删除。",
      "removeTitle": "移除列表：{{name}}",
      "removeText": "确定要移除此列表吗？此操作无法撤销。",
      "copyId": "复制列表 ID",
      "copyIdSuccess": "列表 ID {{id}} 已复制到剪贴板。",
      "refresh": "刷新",
      "delete": "删除",
      "enabledState": "启用",
      "disabledState": "禁用"
    },
    "feeds": {
      "title": "订阅源",
      "description": "管理 RSS、Newznab 和 Torznab 订阅源。",
      "lastRun": "上次运行",
      "nextRun": "下次运行",
      "noItems": "暂无订阅源",
      "noItemsDesc": "通过索引器进行设置",
      "toggleSuccess": "{{name}}已{{state}}成功。",
      "enabledState": "启用",
      "disabledState": "禁用",
      "deleted": "订阅源 {{name}} 已删除",
      "cacheCleared": "订阅源 {{name}} 缓存已清除！",
      "forceRunSuccess": "订阅源 {{name}} 已强制运行成功。",
      "forceRunError": "强制运行 {{name}} 失败。错误：{{error}}",
      "removeTitle": "移除订阅源：{{name}}",
      "removeText": "确定要移除此订阅源吗？此操作无法撤销。",
      "removeCacheTitle": "移除订阅源缓存：{{name}}",
      "removeCacheText": "确定要移除订阅源缓存吗？此操作无法撤销。",
      "forceRunTitle": "强制运行订阅源：{{name}}",
      "forceRunText": "确定要强制运行 {{name}} 订阅源吗？遵守 RSS 抓取间隔规则对于避免 IP 被封非常重要。",
      "toggle": "切换",
      "forceRun": "强制运行",
      "viewLatestRun": "查看最近运行",
      "clearCache": "清除订阅源缓存",
      "clearCacheTitle": "手动清除全部订阅源缓存",
      "delete": "删除"
    }
  }
}
